export const mandateFields = {
  ID: 'id',
  ORIGINATOR_ENTITY: 'originatorLegalEntity',
  ROLE: 'role',
  PHYSICAL_PERSON: 'physicalPerson',
  CONSUMER: 'consumer',
  ACTIVE: 'active',
};
